import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { isNull } from 'lodash';
import { RewardRequestDisplayDTO } from '@/models';

@Component
export default class EditRewardItemActualPriceDialog extends Vue {
  $refs!: {
    formRef: HTMLFormElement;
  };

  @Prop({ default: 'Confirmation' }) title: string;
  @Prop({ default: 'Are you sure you want to cancel this actions?' }) content: string;
  @Prop({ default: 'Cancel' }) cancelAction: string;
  @Prop({ default: 'Confirm' }) confirmAction: string;
  @Prop() request: RewardRequestDisplayDTO;

  private actualPrice = 0;

  @Watch('request', { deep: true, immediate: true })
  onEstimatedPriceChange(): void {
    if (isNull(this.request.actualPrice)) {
      this.actualPrice = this.request.estimatedPrice || 0;
    } else {
      this.actualPrice = this.request.actualPrice;
    }
  }

  formValidate(): boolean {
    return this.$refs.formRef.validate();
  }

  resetForm(): void {
    this.$refs.formRef.reset();
  }

  onConfirmChange(): void {
    if (this.formValidate()) {
      this.$emit('onConfirmChanged', + this.actualPrice);
      this.resetForm();
    }
  }

  onCancelChange(): void {
    this.$emit('onCancelChanged');
  }
}
